// extracted by mini-css-extract-plugin
module.exports = {"metadata-container":"style_metadata-container__VW7F2"};